import React from 'react';
import { Wrapper, Heading, Content, TopIcon, Tnc } from './styles';

const Popup1 = () => (
  <Wrapper>
    <TopIcon>
      <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/icon4.png`} alt="" width="100" />
    </TopIcon>
    <Heading>升頻版本極緻再提升</Heading>
    <br />
    <hr />
    <Content>
    MOOV達成你的臻緻音樂追求，讓你自由選擇享受升頻音樂版本<sup>*</sup>，升頻音質高達 24 bit / 96 kHz。我們精心後製提升音樂取樣頻率，令音色輪廓變得更為鮮明。讓你可按自己的音質喜好，用最高的規格聆聽你最愛的音樂。
    <br />
    <br />
    <Tnc>*根據MOOV針對在香港營運之8大音樂串流平台之內部調查。截至2020年3月16日，MOOV是香港首個及唯一音樂串流平台在流動應用程式內提供 24 bit FLAC無損音樂，當中包括錄音室原音母帶版本及升頻版本的內容。</Tnc>
    </Content>
  </Wrapper>
)

export default Popup1;